<template>
  <SheetContainer
    title="全部功能"
    :desc="`共支持${bottomNavItems.length}个调音功能`"
  >
    <ul class="sheet-list">
      <li
        v-for="(item, index) in bottomNavItems"
        :key="item.id"
      >
      <div ><img 
        class="icon"
        :data-index="index"
        @click="onSelect(item,index,$event)"
        :data-disabled="!computedNavItemAuth(item)"
        :src="computedNavItemAuth(item) ? item.img : item.disabledImg"></div>
        <span>{{ item.name }}</span>
      </li>
    </ul>
  </SheetContainer>
</template>
<script>
import SheetContainer from "../sheet-container/sheet-container.vue";
import { customCollectEvent } from '@/utils/collect';
export default {
  props: {
    bottomNavItems: {
      // 选中值信息
      type: Array,
      default: function(){
        return []
      },
    },
    currentSelectSpeaker: {
      // 选中值信息
      type: Object,
      default: function(){
        return {}
      },
    },
    selection: {
      // 选中信息
      type: Object,
      default: null,
    },
  },
  components: {
    SheetContainer,
  },
  data() {
    return {
      options: [
        { id: 1, name: "连读", checked: false, value: "1" }
      ], // 预置的重读选项
      selectedValue: "", //当前选中的值，未选中或者清除时值为""
      
    };
  },

  computed: {
    removable() {
      return this.selectedValue;
    },
    
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        // debugger
        this.selectedValue = this.value;
      },
    },
  },
  methods: {
    // 获取菜单权限
    computedNavItemAuth(item) {
        let speakerFeature = this.currentSelectSpeaker&&this.currentSelectSpeaker.speakerFeature || []
        return speakerFeature.some((feature) => feature === item.authId)|| item.global
      },
    //插入/修改重读
    onSelect(item,idx,e) {
     this.$emit("selectfun",item,item.type,e)
    },
    // 删除重读
    onRemoveClick() {
      if (!this.isValid()) return;
      this.updateValue("");
    },
    // 更新重读值
    updateValue(newValue) {
      if (newValue !== this.selectedValue) {
        this.selectedValue = newValue;
        this.$emit("update:value", newValue);
        this.$emit("change", newValue);

        const option = this.options.find((option) => option.value === newValue);
        if (option) {
          customCollectEvent("editor_liandu", {
            type: option.name,
          });
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.sheet-list{
  margin-left: -20px;
  margin-right: -20px;
  li:last-child{
    margin-right: 0px;
  }
}
li{
  // width: 80px;
  height: 110px;
  justify-content: center;
  align-items: flex-start;
  text-align: center;
  width: 16.6666%;
  font-size: 20px;
  font-family: 'HarmonyOS_Sans_SC';
  font-weight: 500;
  color: #999999;
}
.icon{
  width: 60px;
  height: 50px;
}
</style>>
</style>